import { put, call, takeEvery } from "redux-saga/effects";

import Actions from "../Actions/Creators";
import Types from "../Actions/Types";
import Phi from "../Phi/Phi";
import Constants from "../Phi/Constants";


function* getVaccinationV2(action) {
    const response = yield call(Phi.Metadata.getVaccinationV2, Phi.Metadata, action);

    if(Boolean(response) && response.ok) {
        yield put(Actions.responseVaccination({ok: true, data: response.data.results}));
    }

    else {
        yield put(Actions.responseVaccination({ok: false}));
    }
}


// Saga Watcher
export function* watchMetadataActions() {
    yield* [
        takeEvery(Types.FETCH_VACCINATION_V2, getVaccinationV2)
    ];
}



// WEBPACK FOOTER //
// ./src/Sagas/MetadataSaga.js